import { SELECT_DAY } from '../actions/selectedDay';
import { SELECT_TEST_DAY } from '../actions/selectedTestDay';
export var selectedDay = function selectedDay() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SELECT_DAY:
      return action.selectedDay;
    case SELECT_TEST_DAY:
      return action.selectedTestDay;
    default:
      return state;
  }
};